module.exports = __webpack_public_path__ + "img/beds.240d5034.svg";